function subhero_close(){
    document.addEventListener("DOMContentLoaded", function() {
    const heroSubhero = document.querySelector(".hero-subhero");
    const heroClose = document.querySelector(".hero-close");

    if (heroClose && heroSubhero) {
        heroClose.addEventListener("click", function() {
            heroSubhero.classList.add("hide");
        });
    }
});
}

export default subhero_close;